module.exports = __webpack_public_path__ + "img/aboutUs.5918c01d.png";